import { debounce as _debounce, throttle as _throttle } from "lodash";
import { submitForm } from "../../lib/helpers.js";

const CookieConsent = el => {
  const submitEl = el.querySelector('._js__cookie-consent__submit');
  const formEl = el.querySelector('._js__cookie-consent__form');
  const checkboxEls = [...el.querySelectorAll('._js__cookie-consent__checkbox')];

  const loadStartEvent = new Event("loadstart");
  const loadEndEvent = new Event("loadend");

  let acceptedGroups = [];
  checkboxEls.forEach(el => {
    if (el.checked) acceptedGroups.push(el.name);
  });

  const onUpdated = json => {
    window.dispatchEvent(loadEndEvent);
    if (json.error) return onFail(json.error);
  };

  // For 'soft' errors, when the API works but can't update.
  const onFail = error => {
    window.dispatchEvent(loadEndEvent);
    console.warn(error);
  }

  // For 'hard' errors, when the API doesn't work.
  const onError = error => {
    window.dispatchEvent(loadEndEvent);
    console.error(error);
  };

  const onSubmit = e => {
    if (el.classList.contains('cookie-modal')) {
      el.classList.add('cookie-modal--hidden');

      const onTransitionEnd = () => {
        el.parentNode.removeChild(el);
      }
  
      el.addEventListener("transitionend", onTransitionEnd);
      el.addEventListener("webkitTransitionEnd", onTransitionEnd);

      if (acceptedGroups.indexOf("group-default-statistics") > -1) {
        if (window.gtag) {
          window.gtag('config', window.gaTrackingCode, { 'anonymize_ip': false });
        }
      };
      
      if (acceptedGroups.indexOf("group-default-marketing") > -1) {
        if (window.fbq) {
          window.fbq('init', window.fbTrackingCode); 
          window.fbq('track', 'PageView');
        }
      }
    }

    e.preventDefault();
    window.dispatchEvent(loadStartEvent);
    const formData = new FormData(formEl);

    try {
      submitForm(formData)
        .then(onUpdated)
        .catch(onError);
    } catch (error) {
      onError(error);
    }
  };

  const onChangeCheckbox = () => {
    acceptedGroups = [];
    checkboxEls.forEach(el => {
      if (el.checked) acceptedGroups.push(el.name);
    });
  }

  formEl.addEventListener('submit', onSubmit);
  checkboxEls.forEach(el => el.addEventListener('change', onChangeCheckbox));
  
  // In the cookies page (not the modal or banner), it auto-submits on clicking a checkbox
  if (!submitEl) {
    checkboxEls.forEach(el => el.addEventListener('change', onSubmit));
  }
};

export default CookieConsent;
